/* Prozone B2B — pz-addresses.js
   Éditeur d'adresses de l'espace client.

   La boutique utilise les nouveaux comptes clients : le thème lit les
   adresses mais ne peut pas les écrire. L'écriture passe par le Manager,
   derrière l'App Proxy Shopify /apps/prozone/addresses — Shopify y ajoute
   lui-même l'identité du client, signée, que le navigateur ne peut pas forger.

   Activation automatique : au chargement on interroge la liste. Si le proxy
   répond un JSON { ok: true, addresses: [...] }, l'éditeur s'affiche ; sinon
   rien ne change et le lien vers la page profil Shopify reste en place.
   Aucune bascule à coordonner avec le Manager.

   Deux règles tenues partout :
   - les données d'adresse passent par textContent, jamais innerHTML ;
   - l'écran est reconstruit depuis la réponse du Manager (relue dans
     Shopify), jamais depuis ce qu'on vient d'envoyer.

   Contrat : docs/PROMPT-manager-adresses.md */
(function () {
  'use strict';

  var box = document.getElementById('pz-addr');
  var cfgEl = document.getElementById('pz-addr-cfg');
  if (!box || !cfgEl || !window.fetch) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = CFG.t || {};
  var COUNTRIES = CFG.countries || {};

  function $(id) { return document.getElementById(id); }

  var list = $('pz-addr-list');
  var form = $('pz-addr-form');
  var title = $('pz-addr-title');
  var formErr = $('pz-addr-formerr');
  var saveBtn = $('pz-addr-save');
  var cancelBtn = $('pz-addr-cancel');
  var addBtn = $('pz-addr-add');
  var nativeLink = $('pz-addr-native');
  var note = $('pz-addr-note');
  var status = $('pz-addr-status');
  var defaultBox = $('pz-addr-setAsDefault');

  var FIELDS = ['company', 'firstName', 'lastName', 'address1', 'address2', 'zip', 'city', 'countryCode', 'phone'];
  var REQUIRED = ['address1', 'zip', 'city', 'countryCode'];
  /* Pays au NPA à quatre chiffres. Le Liechtenstein partage le système postal suisse. */
  var FOUR_DIGIT_ZIP = { CH: 1, LI: 1, AT: 1 };

  var state = { addresses: [], editing: null, busy: false, returnFocus: null };


  /* ----- Réseau ----- */

  function request(method, path, body) {
    var opts = { method: method, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      /* application/json est exigé par le Manager : c'est ce qui bloque une
         requête forgée depuis un autre site. */
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(CFG.base + path, opts).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      /* Proxy absent : Shopify renvoie sa page 404 en HTML. */
      if (ct.indexOf('application/json') === -1) {
        var e = new Error('not_json'); e.status = r.status; throw e;
      }
      return r.json();
    });
  }


  /* ----- Activation ----- */

  request('GET', '').then(function (data) {
    if (!data || data.ok !== true || !Array.isArray(data.addresses)) return;
    state.addresses = data.addresses;
    nativeLink.hidden = true;
    addBtn.hidden = false;
    note.textContent = T.noteLive || '';
    render();
  }).catch(function () {
    /* Pas de proxy, ou Manager indisponible : on garde le repli Shopify. */
  });


  /* ----- Affichage ----- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = text;
    return n;
  }

  function line(parent, cls, text) {
    if (text) parent.appendChild(el('div', cls, text));
  }

  function actionBtn(label, cls, handler) {
    var b = el('button', 'pz-addr__act' + (cls ? ' ' + cls : ''), label);
    b.type = 'button';
    b.addEventListener('click', handler);
    return b;
  }

  function render() {
    list.textContent = '';
    if (!state.addresses.length) {
      var empty = el('div', 'pz-acc__empty', T.empty);
      empty.style.padding = '20px';
      list.appendChild(empty);
      return;
    }
    var grid = el('div', 'pz-acc__addrs');
    state.addresses.forEach(function (a) {
      var card = el('div', 'pz-acc__addr');
      card.setAttribute('data-id', a.id);
      if (a.isDefault) card.appendChild(el('div', 'pz-acc__addrtag', T['default']));
      line(card, 'pz-acc__addrco', a.company);
      line(card, '', [a.firstName, a.lastName].filter(Boolean).join(' '));
      line(card, '', a.address1);
      line(card, '', a.address2);
      line(card, 'pzb-num', [a.zip, a.city].filter(Boolean).join(' '));
      line(card, '', COUNTRIES[a.countryCode] || a.countryCode);
      line(card, 'pzb-num', a.phone);

      var acts = el('div', 'pz-addr__acts');
      acts.appendChild(actionBtn(T.edit, '', function (ev) { openForm(a, ev.currentTarget); }));
      if (!a.isDefault) acts.appendChild(actionBtn(T.makeDefault, '', function (ev) { makeDefault(a, ev.currentTarget); }));
      acts.appendChild(actionBtn(T['delete'], 'pz-addr__act--danger', function (ev) { remove(a, ev.currentTarget); }));
      card.appendChild(acts);
      grid.appendChild(card);
    });
    list.appendChild(grid);
  }

  function say(msg, isError) {
    if (!msg) { status.hidden = true; status.textContent = ''; return; }
    status.className = 'pz-addr__status' + (isError ? ' pz-addr__status--err' : '');
    status.textContent = msg;
    status.hidden = false;
  }


  /* ----- Formulaire ----- */

  function field(name) { return $('pz-addr-' + name); }

  function clearErrors() {
    formErr.hidden = true;
    formErr.textContent = '';
    FIELDS.forEach(function (f) {
      var input = field(f);
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      var old = $('pz-addr-err-' + f);
      if (old) old.parentNode.removeChild(old);
    });
  }

  function fieldError(name, msg) {
    var input = field(name);
    if (!input) return;
    input.setAttribute('aria-invalid', 'true');
    var m = el('span', 'pz-addr__ferr', msg);
    m.id = 'pz-addr-err-' + name;
    input.setAttribute('aria-describedby', m.id);
    input.parentNode.appendChild(m);
  }

  function openForm(addr, trigger) {
    clearErrors();
    say('');
    state.editing = addr ? addr.id : null;
    state.returnFocus = trigger || addBtn;
    title.textContent = addr ? T.titleEdit : T.titleNew;

    FIELDS.forEach(function (f) {
      var input = field(f);
      if (f === 'countryCode') {
        var code = (addr && addr.countryCode) || 'CH';
        /* Pays enregistré mais plus servi : on l'affiche quand même pour ne pas
           le remplacer à l'insu du client ; le Manager tranchera. */
        if (!input.querySelector('option[value="' + code + '"]')) {
          var o = el('option', '', COUNTRIES[code] || code);
          o.value = code;
          input.appendChild(o);
        }
        input.value = code;
      } else {
        input.value = (addr && addr[f]) || '';
      }
    });

    /* L'adresse par défaut ne peut pas être « dé-définie » : Shopify en exige
       toujours une. On l'affiche cochée et figée. La toute première adresse
       devient la valeur par défaut. */
    var isDefault = !!(addr && addr.isDefault);
    defaultBox.checked = isDefault || (!addr && !state.addresses.length);
    defaultBox.disabled = isDefault;

    form.hidden = false;
    addBtn.hidden = true;
    title.focus();
  }

  function closeForm() {
    form.hidden = true;
    addBtn.hidden = false;
    state.editing = null;
    clearErrors();
    var back = state.returnFocus;
    /* Après un re-rendu, le bouton d'origine a pu disparaître. */
    if (back && document.body.contains(back)) back.focus(); else addBtn.focus();
  }

  function values() {
    var v = {};
    FIELDS.forEach(function (f) { v[f] = String(field(f).value || '').trim(); });
    return v;
  }

  /* Contrôle de confort seulement : le Manager revalide tout. */
  function validate(v) {
    var errs = {};
    REQUIRED.forEach(function (f) { if (!v[f]) errs[f] = T.errRequired; });
    if (v.zip && FOUR_DIGIT_ZIP[v.countryCode] && !/^\d{4}$/.test(v.zip)) errs.zip = T.errZipCh;
    return errs;
  }

  function showFieldErrors(errs) {
    var first = null;
    FIELDS.forEach(function (f) {
      if (errs[f]) { fieldError(f, errs[f]); if (!first) first = field(f); }
    });
    if (first) first.focus();
    return !!first;
  }

  var FIELD_CODE = {
    required: 'errRequired', invalid: 'errInvalid',
    too_long: 'errTooLong', country_not_served: 'errCountry'
  };
  var ERROR_CODE = {
    not_logged_in: 'errSession', bad_signature: 'errSession',
    last_address: 'errLast', rate_limited: 'errRate'
  };

  /* Traduit la réponse d'erreur du Manager. Il renvoie des codes, jamais de
     phrases : c'est ici qu'elles deviennent du français, de l'allemand ou de
     l'anglais. */
  function errorMessage(data) {
    var key = data && ERROR_CODE[data.error];
    return T[key || 'errGeneric'];
  }

  function fieldErrorsFrom(data) {
    var out = {};
    if (!data || data.error !== 'validation' || !data.fields) return out;
    Object.keys(data.fields).forEach(function (f) {
      var code = data.fields[f];
      var key = FIELD_CODE[code] || 'errInvalid';
      if (f === 'zip' && code === 'invalid' && FOUR_DIGIT_ZIP[field('countryCode').value]) key = 'errZipCh';
      out[f] = T[key];
    });
    return out;
  }

  function setBusy(on) {
    state.busy = on;
    saveBtn.disabled = on;
    cancelBtn.disabled = on;
    saveBtn.textContent = on ? T.saving : T.save;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (state.busy) return;
    clearErrors();

    var v = values();
    if (showFieldErrors(validate(v))) return;

    var body = { address: v, setAsDefault: defaultBox.checked };
    var path = '/create';
    if (state.editing) { body.id = state.editing; path = '/update'; }

    setBusy(true);
    request('POST', path, body).then(function (data) {
      if (data && data.ok === true && Array.isArray(data.addresses)) {
        state.addresses = data.addresses;
        render();
        closeForm();
        say(T.saved);
        return;
      }
      if (!showFieldErrors(fieldErrorsFrom(data))) {
        formErr.textContent = errorMessage(data);
        formErr.hidden = false;
      }
    }).catch(function () {
      formErr.textContent = T.errGeneric;
      formErr.hidden = false;
    }).then(function () { setBusy(false); });
  });

  cancelBtn.addEventListener('click', closeForm);
  addBtn.addEventListener('click', function () { openForm(null, addBtn); });
  form.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !state.busy) closeForm();
  });


  /* ----- Actions sur une carte ----- */

  function cardAction(path, addr, btn, okMsg) {
    if (state.busy) return;
    state.busy = true;
    btn.disabled = true;
    say('');
    request('POST', path, { id: addr.id }).then(function (data) {
      if (data && data.ok === true && Array.isArray(data.addresses)) {
        state.addresses = data.addresses;
        render();
        say(okMsg);
        addBtn.focus();
        return;
      }
      say(errorMessage(data), true);
    }).catch(function () {
      say(T.errGeneric, true);
    }).then(function () {
      state.busy = false;
      if (document.body.contains(btn)) btn.disabled = false;
    });
  }

  function remove(addr, btn) {
    if (!window.confirm(T.confirmDelete)) return;
    cardAction('/delete', addr, btn, T.deleted);
  }

  function makeDefault(addr, btn) {
    cardAction('/default', addr, btn, T.defaultSet);
  }
})();
